import { INDIVIDUAL_ROLE_ID } from 'constants/roles'
import { canIndividualViewSiteInSitesList } from 'utils/rolePermissions'

/**
 * Client-side row filter for Individuals (defence-in-depth when API scope leaks).
 */
export function filterSitesForIndividualDisplay (sites, profile, isMySite) {
  if (!Array.isArray(sites)) {
    return []
  }
  return sites.filter((site) => canIndividualViewSiteInSitesList(site, profile, isMySite))
}

/**
 * Adjust pagination totals when client filtering removed rows from the current page.
 * Only applies to catalog mode (toggle off); My Sites counts come from the API.
 */
export function adjustPaginationForFilteredSites (apiPagination, requestedSites, visibleSites, profile, isMySite = false) {
  if (!apiPagination || profile?.RoleId !== INDIVIDUAL_ROLE_ID || isMySite) {
    return apiPagination || {}
  }

  const removed = requestedSites.length - visibleSites.length
  if (removed <= 0) {
    return apiPagination
  }

  const resultsPerPage = apiPagination.resultsPerPage || requestedSites.length || 12
  const totalNumber = Math.max(0, (apiPagination.totalNumber || 0) - removed)
  const totalPages = Math.max(1, Math.ceil(totalNumber / resultsPerPage))

  return {
    ...apiPagination,
    totalNumber,
    totalPages
  }
}
